__turbopack_context__.v({
  "adminLayout": "styles-module-scss-module__TPaBSW__adminLayout",
  "formLogin": "styles-module-scss-module__TPaBSW__formLogin",
  "icon": "styles-module-scss-module__TPaBSW__icon",
  "sidebar": "styles-module-scss-module__TPaBSW__sidebar",
  "webLayout": "styles-module-scss-module__TPaBSW__webLayout",
});
